import { ISP_Room } from "./types";
import { themedUseStyletron } from "../../../theme/customTheme";
import { OperationModeIcon } from "./OperationModeIcon";
import { LabelMedium, LabelSmall, ParagraphMedium } from "baseui/typography";
import { Block } from "baseui/block";
import { FormattedMessage } from "react-intl";
import { Badge } from "baseui/badge";

export const OperationModeDisplay = (props: ISP_Room) => {
    const [css, theme] = themedUseStyletron();

    return (
        <Block display='flex' alignItems={"center"} gridGap={theme.sizing.scale300}>
            <OperationModeIcon {...props}></OperationModeIcon>
            {props.isCooling &&
                <Badge hierarchy='secondary' color='accent' content={<FormattedMessage id="SP_Room.IsCooling" defaultMessage="is cooling" />} />
            }
            {props.isHeating &&
                <Badge hierarchy='secondary' color='negative' content={<FormattedMessage id="SP_Room.IsHeating" defaultMessage="is heating" />} />
            }
        </Block>
    )
}